<template>
<div id="AssetSaleCreate" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="purchaseorderHeader" v-if="$route.params.id > 0">Update Asset Sale</span>
                <span class="page-title" id="purchaseorderHeader" v-else>Add Asset Sale</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backToList">
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="AssetSaleForm">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="selling_facility">Sales Type:</label>
                                    <v-select v-model="sales_type" name="sales_type" placeholder="Select Sales Type." label="text" :options="saleTypeArr">
                                    </v-select>
                                    <div class="field-error">{{ sales_type_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="vehicle_id">Asset:</label>
                                    <v-select v-model="vehicle_id" name="vehicle_id"
                                        label="text" :filterable="false" :options="vehicleArr" :disabled="disableAssetField"
                                        @search="onSearchVehicle"
                                        placeholder="Select Asset" class="custom-ci-auto-search">
                                        <template slot="no-options">
                                            Search Asset...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error">{{ vehicle_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="vin">Serial Number</label>
                                    <input :disabled="true" type="text" v-model="vin" id="vin" name="vin" placeholder="Vin" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="year">Equipment Type</label>
                                    <input :disabled="true" type="text" v-model="truck_type" id="truck_type" name="truck_type" placeholder="Equipment Type" class="form-control">
                                </div>
                                </div>
                                <template v-if="active_flag === 'contract'">
                                    <div class="table-responsive-sm">
                                      <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" >
                                        <thead>
                                            <tr class="table-secondary">
                                                <th>Code</th>
                                                <th>Customer</th>
                                                <th>Asset</th>
                                                <th>Contract Type</th>
                                                <th>From Date</th>
                                                <th>To Date</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                          <template v-if="activeArr && activeArr.length > 0">
                                            <tr v-for="(contract, index) in activeArr" :key="index">
                                              <td>
                                                <span>{{contract.code}}</span>
                                              </td>
                                              <td>
                                                <span>{{titleCase(contract.customer)}}</span>
                                              </td>
                                              <td>
                                                <span>{{contract.vehicle}}</span>
                                              </td>
                                              <td>
                                                <span>{{contract.contract_type}}</span>
                                              </td>
                                              <td>
                                                <span>{{contract.from_dt}}</span>
                                              </td>
                                              <td>
                                                <span>{{contract.to_dt}}</span>
                                              </td>
                                              <td>
                                                <span>{{contract.status}}</span>
                                              </td>
                                            </tr>
                                          </template>
                                        </tbody>
                                      </table>
                                    </div>
                                 </template>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label" for="year">Added To Sales List</label>
                                    <input :disabled="true" type="text" v-model="added_to_sales_list" id="added_to_sales_list" name="added_to_sales_list" placeholder="Added To Sales List" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="year">Date Sold</label>
                                    <input :disabled="true" type="text" v-model="sold_date" id="sold_date" name="sold_date" placeholder="Date Sold" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="start_date">Available For Sale:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="available_for_sale" name="available_for_sale" v-model="available_for_sale" :config="optionsDate"></date-picker>
                                        <label for="available_for_sale" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ available_for_sale_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="start_date">Next Inspection Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="next_inspection_date" name="next_inspection_date" v-model="next_inspection_date" :config="optionsDate"></date-picker>
                                        <label for="next_inspection_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ next_inspection_date_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="type">Assigned Facility</label>
                                    <input type="text" :disabled="true" v-model="assigned_facility" id="assigned_facility" name="assigned_facility" placeholder="Assigned Facility" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="selling_facility">Owning Facility:</label>
                                    <v-select v-model="selling_facility" name="selling_facility" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{ selling_facility_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="method">Sales Location:</label>
                                    <v-select v-model="sales_location" name="sales_location" placeholder="Select Location." label="text" :options="salesLocations">
                                    </v-select>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="year">Sold Price</label>
                                    <input :disabled="true" type="text" v-model="sold_price" id="sold_price" name="sold_price" placeholder="Sold Price" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="vendor_id">Contact:</label>
                                    <v-select v-model="sales_person_id" name="sales_person_id" id="sales_person_id" label="text" :options="representativeArr" placeholder="Select User" @input="getPhnNo">
                                    </v-select>
                                    <div class="field-error">{{ sales_person_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="method">Telephone:</label>
                                    <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="phone" id="phone" data-val="PHONE" data-info="Please enter phone number" placeholder="999-999-9999" name="phone"></input>
                                     <!-- <input-mask id="phone" :alwaysShowMask="false" name="phone" v-model="phone" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                    <!-- <input  type="text" v-model="phone" id="phone" name="phone" placeholder="Enter Phone Number" class="form-control"> -->
                                    <div class="field-error">{{ phone_error_msg }}</div>
                                </div>
                                <!-- <div class="col form-group">
                                    <label class="control-label" for="method">Estimated Reconditioning Cost</label>
                                    <input type="text" v-model="reconditioning_cost" id="reconditioning_cost" name="reconditioning_cost" placeholder="Estimated Reconditioning Cost" class="form-control">
                                </div> -->
                                <div class="col form-group">
                                    <label class="control-label" for="method">Net Book Value</label>
                                        <input :disabled="true" type="text" v-model="net_book_value" id="net_book_value" name="net_book_value" placeholder="Net Book Value" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="method">Pricing Value</label>
                                    <input type="text" :disabled="true"
                                    v-model="pricing_value"
                                    id="pricing_value" name="pricing_value" placeholder="Pricing Value" class="form-control">
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="method">List Price</label>
                                    <input type="text" v-model="list_price" id="list_price"
                                    @input="changeListPriceVal($event,'price');"
                                    @blur="getCharges('pricing_value') , list_price = leaveFocus($event);"
                                    @focus="list_price = enterVal($event)"
                                    name="list_price"
                                    placeholder="List Price" class="form-control"
                                    @keypress="isAmountCheck($event)">
                                    <div class="field-error">{{list_price_error_msg}}</div>
                                </div>

                                  <div class="col form-group">
                                    <label class="control-label" for="customer_po">Customer Purchase Order:</label>
                                    <v-select v-model="customer_po" name="customer_po"
                                              label="text" :filterable="false" :options="customerPurchaseOrderArr" :disabled="disableCustomerPoField"
                                              @search="onSearchCustomerPO"
                                              placeholder="Select Customer PO" class="custom-ci-auto-search" @input="customerPOChanged">
                                      <template slot="no-options">
                                        Search Customer Purchase Order...
                                      </template>
                                      <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                          {{ option.text }}
                                        </div>
                                      </template>
                                      <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                          {{ option.text }}
                                        </div>
                                      </template>
                                    </v-select>
                                  </div>

                                <div class="col form-group">
                                    <label  class="control-label">Show on External Document:</label>
                                    <div class="custome-radiobtn">
                                        <div class="form-check form-check-inline">
                                            <label class="boolean optional radio-custom" for="external_document">Yes
                                                <input type="radio" v-model="external_document" :value="'yes'" id="external_document" name="external_document">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <label class="boolean optional radio-custom" for="external_document1"> No
                                                <input type="radio" v-model="external_document" :value="'no'" id="external_document1" name="external_document">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="field-error"></div>
                                </div>

                                <div class="col form-group">
                                    <label  class="control-label">Calculate sales tax according:</label>
                                    <div class="custome-radiobtn">
                                        <div class="form-check form-check-inline">
                                            <label class="boolean optional radio-custom" for="sales_tax">Disposal Facility
                                                <input type="radio" v-model="from_customer" :value="'no'" id="from_customer" name="from_customer">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <label class="boolean optional radio-custom" for="sales_tax"> Customer Facility
                                                <input type="radio" v-model="from_customer" :value="'yes'" id="from_customer1" name="from_customer">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="field-error"></div>
                                </div>
                            </div>
                            <div class="form-row row-cols-md-2 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label" for="method">Comment:</label>
                                    <textarea type="text" v-model="comment" id="comment" rows="5" name="comment" placeholder="Comment" class="form-control rounded-0">
                                    </textarea>
                                    <div class="field-error">{{comment_error_msg}}</div>
                                </div>
                            </div>
                            <div v-if="readingArr && readingArr.length > 0" class="purchase-order-create-main table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Metric</th>
                                            <th scope="col">Date</th>
                                            <th scope="col">Reading</th>
                                            <th scope="col">UOM</th>
                                            <th scope="col">Actual/Est</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(read, index) in readingArr" :key="index">
                                            <td>{{read.secCode}}</td>
                                            <td>{{read.reading_date}}</td>
                                            <td>{{read.reading}}</td>
                                            <td>{{read.unit}}</td>
                                            <td>Actual</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="purchase-order-create-main table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Charge</th>
                                            <th scope="col">Description</th>
                                            <th scope="col" class="require">GL Account</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="rows.length > 0">
                                            <tr v-for="(crow, cindex) in rows" :key="cindex">
                                                <td>
                                                    <v-select v-model="crow.code" name="code" placeholder="Select Code." @input="selectCode(crow.code,cindex)" label="text" :options="codeArr">
                                                    </v-select>
                                                    <div class="field-error">{{crow.code_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Enter Description" v-model="crow.description" name="description" id="description" class="form-control">
                                                    <div class="field-error">{{crow.description_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <v-select v-model="crow.charge_code" id="charge_code" name="charge_code" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="Select Charge" class='custom-ci-auto-search contract-data'>
                                                        <template slot="no-options">
                                                            Search Charge...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{crow.charge_code_error_msg}}</div>
                                                    <!-- <v-select v-model="row.charge_code" :id="'charge_code_'+ index" :name="'charge_code_'+ index" placeholder="Select Charge Code."
                                                                label="text"
                                                                :options="chargesArr" :disabled="disableAll" @input="onChangeGL()">
                                                    </v-select>
                                                    <div class="field-error">{{row.charge_code_error_msg}}</div> -->
                                                </td>
                                                <td>
                                                    <input type="text" :disabled="crow.code && crow.code.text=='DSPTAX'" placeholder="Enter Amount" v-model="crow.amount" name="amount" id="amount" class="form-control text-right" @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{crow.amount_error_msg}}</div>
                                                </td>
                                                <td>&nbsp;&nbsp;&nbsp;
                                                    <a class="" href="javascript:void(0)" v-on:click.prevent="removeElement(cindex);">
                                                        <i class="fp-remove"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr><td colspan="4">No records found.</td></tr>
                                        </template>
                                    </tbody>
                                </table>
                                <div class="field-error">{{charge_duplicate_error_msg}}</div>
                                <div v-if="rows.length < codeArr.length" class="btn-groups">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Line Item
                                    </button>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" v-if="$route.params.id > 0 && !isNext" id="CreateAssetSaleBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetSale">
                                    <i class="fp-reload"> </i> Update
                                </button>
                              <button type="submit" v-else-if="isNext" id="CreateAssetSaleBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetSale(flag='Next')">
                                <i class="fp-save"> </i> Next
                              </button>
                                <button v-else-if="!isNext" type="submit" id="CreateAssetSaleBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetSale">
                                    <i class="fp-save"> </i> Save
                                </button>
                                <button  type="submit" v-if="$route.params.id == undefined && !isNext" id="CreateAndContinueAssetSaleBtn" class="btn btn-tertiary" v-on:click.prevent="CreateAssetSale(flag='Save and Continue')">
                                    <i class="fp-save-continue"> </i> Save and Process Another Sale
                                </button>
                                <button type="submit" id="CancelAssetSaleBtn" class="btn btn-tertiary" v-on:click.prevent="backToList">
                                    <i class="fp-close"> </i> Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>

<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';


export default {
    name: "AssetSaleCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Asset Sale | " +process.env.COPYRIGHT_NAME : "Create Asset Sale | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins: [commonMixins, contractMixins],
    data: () => ({
        isEdit: false,
        permissions: [],
        locationArr: [],
        list_price_on_cwa:0,
        cantAccessPage: "",
        vehicle_id: "",
        vehicleArr:[],
        vehicle_error_msg:'',
        amount:'',
        rate:'',
        start_date:'',
        start_date_error_msg:'',
        loading: false,
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        amount_error_msg :'',
        vin:'',
        truck_type:'',
        added_to_sales_list:'',
        sold_date:'',
        available_for_sale:'',
        available_for_sale_error_msg:'',
        sold_price:'',
        next_inspection_date:'',
        assigned_facility:'',
        selling_facility:'',
        sales_location:'',
        reconditioning_cost:'',
        net_book_value:'',
        pricing_value:'',
        list_price:'',
        selling_facility_error_msg:'',
        next_inspection_date_error_msg:'',
        rows:[],
        comment:'',
        ChargesData:[],
        codeArr:[],
        loadOnce:false,
        readingArr:[],
        sales_type:{text:'Retail',value:'retail'},
        saleTypeArr:[{text:'Retail',value:'retail'},{text:'Wholesale',value:'wholesale'},{text:'Total Loss',value:'total loss'},{text:'Standard Disposal',value:'std'}],
        sales_person_id:'',
        representativeArr:[],
        phone:'',
        sales_person_error_msg:'',
        phone_error_msg:'',
        external_document:'no',
        list_price_error_msg:'',
        sales_type_error_msg:'',
        comment_error_msg:'',
        activeArr:[],
        active_flag: '',
        poolVal:'',
        from_customer:'no',
        accountsArr:[],
        customer_po:null,
        customerPurchaseOrderArr:[],
        disableAssetField: false,
        disableCustomerPoField:false,
        isNext: false,
        customer_po_item_id: '',
        customerPoId: null,
        enableCustomerPO:false,
        charge_duplicate_error_msg: '',
    }),

    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_sales') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        vehicle_id: function(val) {

            var self = this;

            var path = window.location.pathname;
            var segments = path.split("/");

            if ( val.value != "" && val.value != null) {

                self.truck_type = val.typeCode+" | "+val.typeName;
                self.vin = val.vin;
                if(val.locName != null){
                  self.assigned_facility = val.locCode+" | "+val.locName;
                }else{
                  self.assigned_facility = "";
                }


                //self.net_book_value = data.content.net_book_value;
                if ( !segments[3] ) {
                    if(val.phyLocId != null){
                      self.selling_facility = {value:val.phyLocId,text:val.phyLocCode+" | "+val.phyLocName,location_code:val.locCode}
                    }else{
                      self.selling_facility = '';
                    }

                    self.readingDetails();
                    self.getDepSchedule(val.value);
                    self.added_to_sales_list = val.pool_change_date;
                }

                  self.getActiveContractDetail(val.value);

                  self.poolVal = val.pool;

                  self.getCharges('pricing_value');
            }


        },
        rows: {

            handler: function (val, oldVal) {
                // Return the object that changed
                var self  = this;
                //to handle in case when remove last item from charge list
                if ( val.length > 0 ) {

                    var total = 0;
                    for(var i = 0;i < val.length;i++){
                        if (val[i].amount != ''){
                            console.log(val[i].amount);
                            var amount = val[i].amount;
                            if (String(amount).includes(',')){
                                // amount = String(amount).replace(',','');
                                amount = self.removeFormat(amount)
                            }
                            total += parseFloat(amount);
                        }
                    }
                    var index = val.length - 1;
                    var indexamount = val[index].amount;
                    if (String(indexamount).includes(',')) {
                        indexamount = self.removeFormat(indexamount);
                    }
                    if (parseFloat(indexamount) > 0){
                        if (self.list_price != '' && self.removeFormat(self.list_price) > 0 && self.pricing_value != ''){
                            var p_v = self.removeFormat(self.pricing_value);
                            self.list_price = parseFloat(p_v) + parseFloat(total);
                        }else{
                            self.list_price = parseFloat(total);
                        }
                    } else {
                        if (self.pricing_value != ''){
                            var p_v = self.removeFormat(self.pricing_value);
                            self.list_price = parseFloat(p_v) + parseFloat(total);
                        }

                    }

                }
            },
            deep: true
        }

    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     self.role = userObj.roles[0].name;

            // }
            // var dateFormat = userObj["date_format"];
            // if (dateFormat != null) {
            //     self.optionsDate.format = self.getDateTimeFormat(dateFormat);
            // } else {
            //     self.optionsDate.format = self.getDateTimeFormat("mm\dd\YY");
            // }

          if (self.customerPoId == null){
            self.customerPoId = self.$route.params.customerPoId;
          }
          if (self.customerPoId == undefined){
            self.disableAssetField = false;
            self.disableCustomerPoField = false;
          }else{
            // call function to call an api with the customer po id;
            /*
            * Will get the customer PO id when redirected to this page from the customer PO list page. Will need to take that Id and call an api.
            *  that API, in its response will return the purchase order data, for the customer PO filed and the asset data for the Asset field.
            * After getting the data for the two fields, the two fields will be disabled.
            * the api will also return whether there are assets left in the PO to be sold or not.
            * If the assets are left in the PO, then the next button will be displayed instead of the save button.
            * */
            self.getCustomerPOAndItemsDetails(self.customerPoId);
          }
            if ( segments[3]){
                self.loadAssetSale();
            }

            self.getCharges('mount');

        }

        // setTimeout(function () {
        //     self.added_to_sales_list = moment().format("MM/DD/YYYY");
        // }, 500);

        self.getPermissions();
        this.loadFieldData(['depriciation_type','location','disposal_representative']);
        var path = window.location.pathname;
        var segments = path.split("/");

    },
    methods: {

        onSearchVehicle(search, loading) {
            var self = this;
            if (search.length > 3) {

                loading(true);
                self.searchField(loading, search, 'active vehicle status', '');
            }

        },
        onSearchCustomerPO(search, loading) {
          var self = this;
          if (search.length > 3) {

            loading(true);
            self.searchField(loading, search, 'customer_purchase_order_asset', '');
          }

        },
        getCharges: function(flag){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.list_price_error_msg = '';
            if (flag == 'pricing_value' && self.list_price == ''){
                self.list_price_error_msg = 'List Price is Required';
                return;
            }
            var vehicle_id = '';
            if (self.vehicle_id != null && self.vehicle_id.value){
                vehicle_id = self.vehicle_id.value;
            }
            var location_id = '';
            if (self.vehicle_id != null && self.vehicle_id.locCode){
                location_id = self.vehicle_id.locCode;
            }
            $.ajax({
                url: process.env.ROOT_API + "/get-sale-charges",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_id:vehicle_id,
                    selling_facility_code:location_id
                },
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        if ( data.content && data.content.length ) {

                            var arrData = data.content;
                            self.ChargesData = arrData;
                            self.codeArr = [];
                            for (var i = 0; i < arrData.length; i++){
                                // self.codeArr.push({text:arrData[i].charge_identifier,value:arrData[i].charge_identifier});
                                self.codeArr.push({text:arrData[i].charge_name,value:arrData[i].charge_identifier,gl_account_id:{text:arrData[i].gl_code+' | '+arrData[i].gl_description,value:arrData[i].gl_account_id}});
                            }
                            if (flag == 'pricing_value'){
                                if (self.rows.length == undefined || self.rows.length < 1){
                                    self.rows = [];
                                    
                                    self.rows.push({
                                        code: '',
                                        code_error_msg:'',
                                        description: '',
                                        description_error_msg:'',
                                        charge_code:"",
                                        charge_code_error_msg:"",
                                        percentage:'',
                                        amount: '',
                                        amount_error_msg:'',
                                    },{
                                        code: '',
                                        code_error_msg:'',
                                        description: '',
                                        description_error_msg:'',
                                        charge_code:"",
                                        charge_code_error_msg:"",
                                        percentage:'',
                                        amount: '',
                                        amount_error_msg:'',
                                    },{
                                        code: '',
                                        code_error_msg:'',
                                        description: '',
                                        description_error_msg:'',
                                        charge_code:"",
                                        charge_code_error_msg:"",
                                        percentage:'',
                                        amount: '',
                                        amount_error_msg:'',
                                    });
                                }
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')

                }
            });
        },
        onSearchAccount(search, loading) {
            var self = this;
            if (search.length > 3) {

                loading(true);
                self.searchField(loading, search, 'accounts', '');
            }
        },
        selectCode: function(code,i){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            var amount = 0;
            if (!segments[3] || self.loadOnce == true){
                if (code != '' && code != undefined){
                    code = code.value;

                    console.log(self.ChargesData);
                    //get index of selected  charge code
                    var index = self.ChargesData.map(function(o) { return o.charge_identifier; }).indexOf(code);
                    if (code == 'DSPTAX'){
                        self.rows[i].percentage = self.ChargesData[index].rate;
                        var p_v = self.pricing_value;

                        amount = (parseFloat(p_v.replace(/[^.\d]/g, '')) * self.ChargesData[index].rate) / 100
                    }else{
                        amount = self.ChargesData[index].rate;
                    }
                    self.rows[i].code_error_msg = '';

                    // self.rows[i].quantity = 1;
                    // self.rows[i].price = self.ChargesData[index].rate;
                    self.rows[i].description=  self.ChargesData[index].charge_name;
                    self.rows[i].description_error_msg = '';

                    self.rows[i].amount = amount;
                    self.rows[i].amount_error_msg = '';
                }
            }
            if (self.rows[i].code.gl_account_id != undefined && self.rows[i].code.gl_account_id.value != undefined && self.rows[i].code.gl_account_id.value != null){
                self.rows[i].charge_code = self.rows[i].code.gl_account_id;
            }else{
                self.rows[i].charge_code = '';
            }
            setTimeout(function(){

                self.loadOnce = true;

            },1000);

        },
        getPhnNo: function(){
            var self = this;
            self.phone = self.sales_person_id.phone;
        },
        getDepSchedule: function(vehicleId) {
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/depreciation-schedule/getDepScheduleByVehicle",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_id:vehicleId
                },
                success: function (data) {

                    self.loading = false;
                    if (data.status == "success") {

                        self.net_book_value = data.content.net_book_value;

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')

                }
            });
        },
        readingDetails: function(){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/reading-detail-by-vehicle",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_id:self.vehicle_id.value
                },
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    self.readingArr = [];

                    if (data.status == "success") {
                        if (data.content && data.content.length){
                           self.readingArr = data.content;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')

                }
            });
        },

        CreateAssetSale(flag) {
          var self = this;

            var error = false;
            self.vehicle_error_msg = "";
            self.phone_error_msg = '';
            self.selling_facility_error_msg = '';
            self.available_for_sale_error_msg = '';
            self.sales_person_error_msg = '';
            self.list_price_error_msg = '';
            self.sales_type_error_msg = '';
            self.comment_error_msg = '';

            if (self.sales_type == null || !self.sales_type.value) {
                self.sales_type_error_msg = "Sales Type is Required.";
                error = true;
            }

            if (self.vehicle_id == null || !self.vehicle_id.value) {
                self.vehicle_error_msg = "Asset is Required.";
                error = true;
            }

            if (self.selling_facility == null || !self.selling_facility.value) {
                self.selling_facility_error_msg = "Facility is Required.";
                error = true;
            }

            if (self.sales_person_id == null || !self.sales_person_id.value) {
                self.sales_person_error_msg = "Contact is Required.";
                error = true;
            }

            if (self.available_for_sale == null || self.available_for_sale == '') {
                self.available_for_sale_error_msg = "Date is Required.";
                error = true;
            }

            if (self.list_price == null || self.list_price == '' || self.list_price <= 0) {
                self.list_price_error_msg = "List Price is Required.";
                error = true;
            }
            // if (self.comment == null || self.comment == '') {
            //     self.comment_error_msg = "Comment is Required.";
            //     error = true;
            // }

            var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

            if(self.phone && !self.phone.match(phoneRE)){
                self.phone_error_msg = "Phone number must be in proper format";
                error = true;
            }
            // if(self.telephone && !self.telephone.length != 10){
            //     self.telephone_error_msg = "Phone number must be in 10 digit";
            //     error = true;
            // }
            var filled = 0; var blank = 0;

            for (var i = 0; i < self.rows.length; i++) {
                self.rows[i].code_error_msg = "";
                self.rows[i].description_error_msg = "";
                self.rows[i].amount_error_msg = "";
                self.rows[i].charge_code_error_msg = "";

                if (self.rows[i].code == null || self.rows[i].code == '' || !self.rows[i].code) {
                    self.rows[i].code_error_msg = "Code is Required.";
                    // error = true;
                    blank=1;
                }else{
                    filled = 1;
                }

                if (self.rows[i].amount == null || !self.rows[i].amount || self.rows[i].amount < 0.1) {
                    self.rows[i].amount_error_msg = "Amount is Required.";
                    // error = true;
                    blank=1;
                }else{
                    filled = 1;
                }


                if (self.rows[i].description == null || self.rows[i].description == '' || !self.rows[i].description) {
                    self.rows[i].description_error_msg = "Description is Required.";
                    // error = true
                    blank=1;
                }else{
                    filled = 1;
                }

                if (self.rows[i].charge_code == null || self.rows[i].charge_code == '' || !self.rows[i].charge_code.value) {
                    self.rows[i].charge_code_error_msg = "GL account is Required.";
                    // error = true
                    blank=1;
                }else{
                    filled = 1;
                }

                if ( filled == blank ) {
                    error = true;
                } else {

                    //remove line if no data input
                    if ( blank != 0 ) {
                        self.removeElement(i);
                        i = 0;
                    }
                }
                var duplicate = 0;
                self.rows.forEach((item, index) => {
                    if(item.code.text == self.rows[i].code.text){
                        duplicate++;
                    }
                });

                if(duplicate > 1){
                    error = true;
                    self.charge_duplicate_error_msg = "Charges are duplicate.";
                }
            }

            if (!error) {

                if (self.poolVal != '' && (self.poolVal != 'SLL' && self.poolVal != 'SLR' && self.poolVal != 'SLL-P' && self.poolVal != 'SLR-P')){
                    self.$swal('','Asset is not in sales lot pool','info');
                    return;
                }
                if(self.active_flag == 'contract'){
                    if (confirm('Selected Asset is under active contract. Are you sure that you want to Continue? ')) {
                        //   if (confirm('Remaining depreciation will be removed. Are you sure that you want to Continue? ')) {
                        //     self.createSale(flag);
                        //   }
                        // if (confirm('Unit is not currently in the sales lot pool. Are you sure that you want to Continue? ')) {
                            self.createSale(flag);
                        // }
                    }
                } else {
                        // self.createSale(flag);
                        // if (confirm('Unit is not currently in the sales lot pool. Are you sure that you want to Continue? ')) {
                            self.createSale(flag);
                        // }
                }
            }else{
                self.errorValidationFocus();
            }

        //   if(self.active_flag == 'contract'){
        //       if (confirm('Selected Asset is under active contract. Are you sure that you want to Continue? ')) {
        //         self.createSale(flag);
        //       }
        //   } else {
        //         self.createSale(flag);
        //   }

        },
        createSale:function(flag){
           var self = this;

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                $("#CreateAssetSaleBtn").val("Updating ...");
                $("#CreateAssetSaleBtn").prop("disabled", true);
                $("#CancelAssetSaleBtn").prop("disabled", true);
            } else {
                if (flag == "Save and Continue") {

                    $("#CreateAndContinueAssetSaleBtn").val("Saving ...");
                    $("#CreateAssetSaleBtn").prop("disabled", true);
                    $("#CreateAndContinueAssetSaleBtn").prop("disabled", true);
                    $("#CancelAssetSaleBtn").prop("disabled", true);

                } else {

                    $("#CreateAssetSaleBtn").val("Saving ...");
                    $("#CreateAssetSaleBtn").prop("disabled", true);
                    $("#CreateAndContinueAssetSaleBtn").prop("disabled", true);
                    $("#CancelAssetSaleBtn").prop("disabled", true);
                }
            }

            var fields = $("#AssetSaleForm").serializeArray();
            // alert(JSON.stringify(fields));


            if (self.vehicle_id == null) {
                fields.push({
                    name: "vehicle_id",
                    value: ""
                });
            } else {
                fields.push({
                    name: "vehicle_id",
                    value: self.vehicle_id.value
                });
            }

            fields.push({
                name: "rows",
                value: JSON.stringify(self.rows)
            });

            fields.push({
                name: "list_price_on_cwa",
                value: self.list_price_on_cwa
            });

            var p_v = self.removeFormat(self.pricing_value);
            fields.push({
                name: "pricing_value",
                value: p_v
            });

            fields.push({
                name: "list_price",
                value: self.removeFormat(self.list_price)
            });

            fields.push({
                name: "assigned_facility",
                value: self.assigned_facility
            });

            var nbv = self.net_book_value;

            fields.push({
                name: "net_book_value",
                value: nbv.replace(/[^.\d]/g, '')
            });

            fields.push({
                name: "added_to_sales_list",
                value: self.added_to_sales_list
            });

            fields.push({
                name: "flag",
                value: 'create'
            });
            fields.push({
                name: "active_contract",
                value: self.active_flag
            });

            if (self.selling_facility == null) {
                fields.push({
                    name: "selling_facility",
                    value: ""
                });
            } else {
                fields.push({
                    name: "selling_facility",
                    value: self.selling_facility.value
                });
            }

            if (self.sales_type == null) {
                fields.push({
                    name: "sales_type",
                    value: ""
                });
            } else {
                fields.push({
                    name: "sales_type",
                    value: self.sales_type.value
                });
            }

            if (self.sales_person_id == null) {
                fields.push({
                    name: "sales_person_id",
                    value: ""
                });
            } else {
                fields.push({
                    name: "sales_person_id",
                    value: self.sales_person_id.value
                });
            }
            if(self.phone == null){
                fields.push({
                name: "phone",
                value: ''
                });
            }else{
                fields.push({
                name: "phone",
                value: self.phone
                });
            }

            if (self.sales_location == null) {
                fields.push({
                    name: "sales_location",
                    value: ""
                });
            } else {
                fields.push({
                    name: "sales_location",
                    value: self.sales_location.value
                });
            }

            fields.push({
                name: "id",
                value: segments[3]
            });

            if (self.customer_po != null || self.customer_po !== ''){
              fields.push({
                name:"customer_po_id",
                value: self.customer_po.value
              });

              fields.push({
                name:"customer_po_item_id",
                value: self.customer_po_item_id
              });
            }
            $.ajax({
                url: process.env.ROOT_API + "/asset-sale/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false; console.log(data.prevent_disposal);
                    if(data.prevent_disposal == "Yes"){

                        self.$swal('',data.message,'info');
                        $("#CreateAssetSaleBtn").val("Saving ...");
                        $("#CreateAssetSaleBtn").prop("disabled", false);
                        $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                        $("#CancelAssetSaleBtn").prop("disabled", false);
                        return;

                        }
                    if (segments[3]) {
                        $("#CreateAssetSaleBtn").val("Update");
                        $("#CreateAssetSaleBtn").prop("disabled", false);
                        $("#CancelAssetSaleBtn").prop("disabled", false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#CreateAndContinueAssetSaleBtn").val("Save and Continue");
                            $("#CreateAssetSaleBtn").prop("disabled", false);
                            $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                            $("#CancelAssetSaleBtn").prop("disabled", false);

                        } else {

                            $("#CreateAssetSaleBtn").val("Save");
                            $("#CreateAssetSaleBtn").prop("disabled", false);
                            $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                            $("#CancelAssetSaleBtn").prop("disabled", false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#AssetSaleForm").trigger("reset");

                            self.vehicle_id = '';
                            self.added_to_sales_list = '';
                            self.available_for_sale = '';
                            self.vin = '';
                            self.truck_type = '';
                            self.sold_date = '';
                            self.sold_price = '';
                            self.next_inspection_date = '';
                            self.selling_facility = '';
                            self.sales_location = '';
                            self.assigned_facility = '';
                            // self.list_price_on_cwa = '';
                            self.reconditioning_cost = '';
                            self.sales_person_id = '';
                            self.phone = '';
                            self.net_book_value = '';
                            self.pricing_value = '';
                            self.list_price = '';
                            self.comment = '';
                            self.external_document = 'no';
                            self.from_customer = 'no';
                            self.readingArr = [];
                            self.rows = [];
                            self.active_flag = '';

                        }

                        else if(flag == "Next" && !segments[3]){
                          $("#AssetSaleForm").trigger("reset");

                          self.vehicle_id = '';
                          self.added_to_sales_list = '';
                          self.available_for_sale = '';
                          self.vin = '';
                          self.truck_type = '';
                          self.sold_date = '';
                          self.sold_price = '';
                          self.next_inspection_date = '';
                          self.selling_facility = '';
                          self.sales_location = '';
                          self.assigned_facility = '';
                          // self.list_price_on_cwa = '';
                          self.reconditioning_cost = '';
                          self.sales_person_id = '';
                          self.phone = '';
                          self.net_book_value = '';
                          self.pricing_value = '';
                          self.list_price = '';
                          self.comment = '';
                          self.external_document = 'no';
                          self.from_customer = 'no';
                          self.readingArr = [];
                          self.rows = [];
                          self.active_flag = '';
                          self.customer_po = '';

                          self.customerPoId = data.customer_po_id;
                          self.getCustomerPOAndItemsDetails(self.customerPoId);
                          // self.$router.push({ name: 'AssetSaleCreate', params:{customerPoId}});
                        }
                        else {
                            self.$router.push("/asset-sale/list/");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3]) {
                        $("#CreateAssetSaleBtn").val("Update");
                        $("#CreateAssetSaleBtn").prop("disabled", false);
                        $("#CancelAssetSaleBtn").prop("disabled", false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#PurchaseOrderForm").trigger("reset");
                            $("#CreateAndContinueAssetSaleBtn").val("Save and Continue");
                            $("#CreateAssetSaleBtn").prop("disabled", false);
                            $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                            $("#CancelAssetSaleBtn").prop("disabled", false);

                        } else {

                            $("#CreateAssetSaleBtn").val("Save");
                            $("#CreateAssetSaleBtn").prop("disabled", false);
                            $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                            $("#CancelAssetSaleBtn").prop("disabled", false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-create')

                }
            });





        },


        loadAssetSale() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/asset-sale/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data.content.vehicle);

                        if (data.status == "success") {

                            var dataSet = data.content.vehicle;
                            self.vehicle_id = {
                                                text:dataSet.unit_no+' | '+dataSet.vtCode+' | '+dataSet.vtName+' | '+dataSet.lName,
                                                value:dataSet.vehicle_id,
                                                vin:dataSet.vin,
                                                locCode:dataSet.asLocCode,
                                                locName:dataSet.asLocName,
                                                typeCode:dataSet.vtCode,
                                                typeName:dataSet.vtName,
                                                pool:dataSet.pool_code
                                                };
                            self.added_to_sales_list = dataSet.added_to_sales_list;
                            self.available_for_sale = dataSet.available_for_sale;
                            self.sold_date = dataSet.sold_date;
                            self.sold_price = dataSet.sold_price;
                            self.next_inspection_date = dataSet.next_inspection_date;
                            self.selling_facility = {value:dataSet.selling_facility,text:dataSet.lCode+' | '+dataSet.lName};
                            if (dataSet.salesLocValue != null ) {
                                self.sales_location = {text:dataSet.salesLocText,value:dataSet.salesLocValue};
                            }

                            self.list_price_on_cwa = dataSet.list_price_on_cwa;
                            self.reconditioning_cost = dataSet.estimate_reconditioning_cost;
                            self.net_book_value = dataSet.net_book_value;
                            self.pricing_value = self.amountFormat(dataSet.pricing_value);
                            self.list_price = self.amountFormat(dataSet.list_price);
                            self.comment = dataSet.comments;
                            self.phone = dataSet.telephone;

                            if(dataSet.customer_po_id !== '' || dataSet.customer_po_id != null){
                              self.customer_po = {
                                text:dataSet.po_no,
                                value:dataSet.customer_po_id
                              };
                              self.disableAssetField = true;
                              self.customer_po_item_id = dataSet.customer_po_item_id;
                            }

                            self.sales_type = {text:self.titleCase(dataSet.sales_type),value:dataSet.sales_type};
                            if  (dataSet.repId){

                                self.sales_person_id = {text:self.titleCase(dataSet.sales_person_id),value:dataSet.repId};

                            }
                            self.external_document = dataSet.show_on_external_document;
                            self.from_customer = dataSet.customer_wise_sale_tax;
                            var arrData = dataSet.charges_item;

                            for (var i = 0; i < arrData.length; i++){
                                var amount = 0;
                                if (arrData[i].code == 'DSPTAX'){
                                    self.rows.push({
                                        code: {text:arrData[i].description,value:arrData[i].code},
                                        code_error_msg:'',
                                        // quantity: arrData[i].quantity,
                                        // price: arrData[i].price,
                                        percentage:arrData[i].percentage,
                                        description: arrData[i].description,
                                        description_error_msg:'',
                                        charge_code:{text:arrData[i].charge_code.text,value:arrData[i].charge_code.value},
                                        charge_code_error_msg:"",
                                        amount: arrData[i].amount,
                                        amount_error_msg:'',
                                    });
                                }else{
                                    self.rows.push({
                                        code: {text:arrData[i].description,value:arrData[i].code},
                                        code_error_msg:'',
                                        // quantity: arrData[i].quantity,
                                        // price: arrData[i].price,
                                        description: arrData[i].description,
                                        description_error_msg:'',
                                        charge_code:{text:arrData[i].charge_code.text,value:arrData[i].charge_code.value},
                                        charge_code_error_msg:"",
                                        amount: arrData[i].amount,
                                        amount_error_msg:'',
                                    });
                                }

                            }

                            if (dataSet.posted == 'yes'){
                                self.$swal('','Asset Sale Bill Already Posted','info');
                                self.$router.push("/asset-sale/list/");
                            }

                            self.getCharges('mount');
                            self.loadOnce = true;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-sale-load')

                    }
                });
        },

        addRow: function () {

            var self = this;
            var j = self.rows.length;
            var i = j - 1;
            var error = false;
            var path = window.location.pathname;
            var segments = path.split("/");

            if ( j > 0 ) {

            //     if (self.rows[i].code == null || self.rows[i].code == '' || !self.rows[i].code) {
            //         self.rows[i].code_error_msg = "Code is Required.";
            //         error = true;
            //     }

            //     if (self.rows[i].amount == null || !self.rows[i].amount || self.rows[i].amount < 0.1) {
            //         self.rows[i].amount_error_msg = "Amount is Required.";
            //         error = true;
            //     }

            //     if (self.rows[i].description == null || self.rows[i].description == '' || !self.rows[i].description) {
            //         self.rows[i].description_error_msg = "Description is Required.";
            //         error = true;
            //     }
            // }

            // if ( j == 0 || error == false) {

                if ( j > 0 ) {
                    self.rows[i].code_error_msg = "";
                    self.rows[i].description_error_msg = "";
                    self.rows[i].amount_error_msg = "";
                    self.rows[i].charge_code_error_msg = "";
                }

                self.rows.push({
                    code: '',
                    code_error_msg:'',
                    // quantity: '',
                    // price: '',
                    description: '',
                    description_error_msg:'',
                    charge_code:"",
                    charge_code_error_msg:"",
                    amount: '',
                    amount_error_msg:'',
                });

            }else {
                if (segments[3]){
                    self.rows.push({
                        code: '',
                        code_error_msg:'',
                        // quantity: '',
                        // price: '',
                        description: '',
                        description_error_msg:'',
                        charge_code:"",
                        charge_code_error_msg:"",
                        amount: '',
                        amount_error_msg:'',
                    });
                }
            }

        },
        removeElement: function (index) {

            var self = this;

            if ( index == 0 ) {
                if (self.rows[index].amount != ''){
                    var amount = self.rows[index].amount;
                    amount = String(amount).replace(',','');
                    if (self.list_price != ''){
                        var p_v = self.removeFormat(self.list_price);
                        self.list_price = parseFloat(p_v) - parseFloat(amount);
                    }
                }
            }

            self.rows.splice(index, 1);

        },
        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        isNumberCheck: function (evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        backToList: function(){
            var self = this;

            self.$router.push('/asset-sale/list');
        },
        changeSellingFacility:function(){
            var self  = this;

            if (self.selling_facility.value){
                self.sales_location = self.selling_facility;
            }
        },
        changeListPriceVal:function(evt,flag){
            var self = this;
            if (flag == 'price' && self.list_price != ''){
                var l_p = self.list_price;
                self.pricing_value = l_p;
            }
        },
        calculateDiscount: function(dis,index){
            var self = this;

            var amount = (self.pricing_value * dis) / 100;

            self.rows[index].amount = amount;
        },
        getActiveContractDetail:function(vehicleId){
          var self = this;
          $.ajax({
                url: process.env.ROOT_API + "/contractdetail/list",
                type: "POST",
                data: {
                        vehicle_id : vehicleId
                      },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.code == 200) {
                            self.activeArr = data.content;
                            self.active_flag = 'contract';
                    }else{
                      self.active_flag = '';
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'contract-detail-error')

                }
            });

        },
        getCustomerPOAndItemsDetails(customerPoId){
          var self = this;
          self.loading = true;
          $.ajax({
            url: process.env.ROOT_API + "/po-items-asset-detail/" + customerPoId,
            type: "GET",
            headers: {
              "Accept": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Authorization": "Bearer " + localStorage.getItem("tkn"),
              "Access-Control-Allow-Headers": "Origin, Content-Type, Authorization,X-Requested-With",
              "Cache-Control": "no-cache"
            },
            dataType: "json",
            success: function (data) {
              self.loading = false;

              if (data.status == "success") {

                self.vehicle_id = {
                  text:data.content.customer_po_items.asset_unit_no+' | '+data.content.customer_po_items.vt_code+' | '+data.content.customer_po_items.vehicle_name+' | '+data.content.customer_po_items.location_name,
                  value:data.content.customer_po_items.vehicle_id,
                };
                self.customer_po = {
                  text:data.content.customer_po.po_no,
                  value:data.content.customer_po.id
                };
                self.customer_po_item_id = data.content.customer_po_items.customer_po_item_id;
                if (data.content.next_exist == "true"){
                  self.isNext = true
                }else{
                  self.isNext = false
                }
                self.disableAssetField = true;
                if (self.enableCustomerPO){
                  self.disableCustomerPoField = false;
                }else{
                  self.disableCustomerPoField = true;
                }
              }
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')
              self.disableAssetField = false;
              self.disableCustomerPoField = false;
            }
          });

        },
      customerPOChanged(){
          var self = this;
        if (self.customer_po != null || self.customer_po !== ''){
          if (self.customer_po.value != null || self.customer_po.value !== ''){
            self.enableCustomerPO = true;
            self.getCustomerPOAndItemsDetails(self.customer_po.value);
          }
        }
      },

    }
};
</script>





// WEBPACK FOOTER //
// src/components/asset/AssetSaleCreate.vue